export default __webpack_public_path__ + "static/Governance_01-a2e5534f941bbabace2b9d6c0e11051d.jpg";